import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'


import '../src/app/_metronic/assets/sass/style.react.scss'
import '../src/app/_metronic/assets/fonticon/fonticon.css'
import '../src/app/_metronic/assets/keenicons/duotone/style.css'
import '../src/app/_metronic/assets/keenicons/outline/style.css'
import '../src/app/_metronic/assets/keenicons/solid/style.css'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import '../src/app/_metronic/assets/sass/style.scss'
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { store } from './app/redux/store';
import MainApp from './MainApp';

import './CustomCss.css'
import "./Tooltip.css";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <Provider store={store}>
        <Toaster
            position="bottom-right"
            reverseOrder={false}
            toastOptions={{
                duration: 5000
            }}
        />

        <MainApp />

    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
